export default __webpack_public_path__ + "static/bumpa-onboarding-b4d07661137cacbb06e86faff12972e7.mp4";